
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
if (!Array.prototype.find) {
  Array.prototype.find = function(predicate) {
    if (this === null) {
      throw new TypeError('Array.prototype.find called on null or undefined');
    }
    if (typeof predicate !== 'function') {
      throw new TypeError('predicate must be a function');
    }
    var list = Object(this);
    var length = list.length >>> 0;
    var thisArg = arguments[1];
    var value;

    for (var i = 0; i < length; i++) {
      value = list[i];
      if (predicate.call(thisArg, value, i, list)) {
        return value;
      }
    }
    return undefined;
  };
}


if (!Array.prototype.findId) {
  Array.prototype.findId = function(id) {
    return this.find(function(item) { return item.id === id; });
  }
}

if (!Array.prototype.groupBy) {
    Array.prototype.groupBy = function(predicate) {

        if (this.length === 0) { return []; }

        var groups = [], i, currentGroup;
        var mapped = this.slice(0, this.length).map(function(item, i) {
            return {index: i, value: predicate(item) }
        });

        mapped.sort(function(a, b) {
            return +(a.value > b.value) || +(a.value === b.value) - 1;
        });

        currentGroup = {value: mapped[0].value, items: []};
        for (i = 0; i < mapped.length; i++) {
            if (currentGroup !== mapped[i].value) {
                groups.push(currentGroup);
                currentGroup = {value: mapped[i].value, items: []};
            }
            currentGroup.items.push(this[mapped[i].index]);
        }
        groups.push(currentGroup);
        return groups;
    }
}